// Outbound dialer tenant pre-fill (idle screen v3, 2026-09-19).
//
// Same rule as D26 / PR #84's caller history: the tenant comes from context
// the console already holds — never from a build-time VITE_TENANT_ID, never a
// hardcoded default, and never a tenant the agent is not entitled to. When
// nothing qualifies the field stays empty and the agent chooses; the
// confirmation step (PR #80) still shows the tenant before any call is placed.
//
// Precedence:
//   1. task     — an explicit pre-fill (an accepted callback task's own tenant)
//   2. last-contact — the tenant of the contact this agent just finished,
//                   read from that contact's own tenantId attribute. Idle
//                   dialer only: when a task pre-fill was supplied, the
//                   last contact is never substituted for it.
//   3. only-tenant — the agent is entitled to exactly one tenant
//   4. none     — empty; the agent picks
//
// Pure: no React, no Streams, no fetch — scripts/verify-idle-screen-v3.mjs
// runs it directly.

const usable = (t, entitled) => typeof t === 'string' && t.trim() !== '' && entitled.includes(t);

export function pickDialerTenant({ initialTenantId = '', lastContactTenantId = null, entitled = [] } = {}) {
  const list = Array.isArray(entitled) ? entitled : [];
  if (usable(initialTenantId, list)) return { tenantId: initialTenantId, source: 'task' };
  const hasTaskPrefill = typeof initialTenantId === 'string' && initialTenantId.trim() !== '';
  if (!hasTaskPrefill && usable(lastContactTenantId, list)) {
    return { tenantId: lastContactTenantId, source: 'last-contact' };
  }
  if (list.length === 1) return { tenantId: list[0], source: 'only-tenant' };
  return { tenantId: '', source: 'none' };
}

// Reducer helper: the tenant to remember when a contact's workspace is
// cleared. Reads the ending contact's own attribute (display.tenantId, the
// same field #84's history panel keys on); a clear with no display — a second
// onEnded after save, a missed offer — keeps what was already known.
export function lastContactTenantAfter(display, previous = null) {
  const t = display?.tenantId;
  return typeof t === 'string' && t.trim() !== '' ? t : previous;
}
